import { render, staticRenderFns } from "./MyAccountHeader.vue?vue&type=template&id=5b4ec9cc"
import script from "./MyAccountHeader.vue?vue&type=script&lang=js"
export * from "./MyAccountHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports